<template>
  <div class="rc-but-list" :class="{ 'bottom16': bottom16 }">
    <template v-for="(but, _index) in butData">
      <rc-button
        v-if="!but.display"
        :key="but.prop"
        v-bind="but"
        :disabled="but.disabled || disabled(but)"
        @click="clickHandle(but, _index, $event)"
        v-on="{ ...$listeners, ...but.events }"
      >
        <slot :row="but" :index="_index" :disabled="but.disabled || disabled(but)">
          {{ but.label }}
          <i v-if="but.iconClass" :class="but.iconClass"></i>
          <img v-if="but.img" :src="require(`@/assets/images/${but.img}`)" :alt="but.img" />
        </slot>
      </rc-button>
    </template>
  </div>
</template>

<script>
import RcButton from "../RcBase/RcButton";
import { emitFun } from "@/utils";

export default {
  name: "RcButList",
  components: { RcButton },
  props: {
    type: String,
    butData: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Function,
      default: () => false
    },
    bottom16: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    clickHandle(item, index, event) {
      // form需要阻止表单的默认行为
      this.type === "form" && event.preventDefault();
      emitFun({ self: this, emit: true }, { item, index }, { name: "rcButList", event });
    },
    router(data, index) {
      const { name, key, rowKey } = data;
      this.$router.push({ name, query: { [key || "id"]: this.item[rowKey] }});
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom16 {
  margin-bottom: 16px;
}
</style>
